import type React from 'react';

export const EmptyView: React.FC = () => {
    return null;
};
